import { Field, Form, Formik } from "formik";
import { useIntl } from "react-intl";
import { Input } from "../../../common/components/control/InputField";
import { memberTransferSchema } from "../yupSchema/memberTransferSchema";
import { useAuth } from "../../../auth/components/AuthInit";

export const MemberTransferForm = ({ formikRef, saveValues, mainWallet }) => {
  const intl = useIntl();
  const { auth } = useAuth();

  return (
    <Formik
      initialValues={{
        amount: "",
        receiverUsername: "",
      }}
      innerRef={formikRef}
      validationSchema={memberTransferSchema(intl)}
      enableReinitialize={true}
      onSubmit={(values, formikHelpers) => {
        const queryParams = {
          amount: values.amount,
          selusername: values.receiverUsername,
        };

        saveValues(queryParams);
      }}
    >
      {({
        values,
        handleSubmit,
        setFieldValue,
        touched,
        errors,
        setFieldError,
      }) => (
        <Form>
          <div className="mb-2">
            <Field
              name="receiverUsername"
              component={Input}
              placeholder={intl.formatMessage({ id: "receiverUsername" })}
              label={intl.formatMessage({ id: "receiverUsername" })}
              autoComplete="off"
              type="text"
              isUpperCaseOnly={true}
            />
          </div>
          <div className="mb-2 position-relative">
            <Field
              name="amount"
              component={Input}
              placeholder={intl.formatMessage({ id: "amount" })}
              label={intl.formatMessage({ id: "amount" })}
              autoComplete="off"
              type="number"
            />
            <div
              className="position-absolute text-prim cursor-pointer"
              style={{ right: "35px", top: "39px" }}
              onClick={() => {
                const [mainBal] = mainWallet.split(".");

                setFieldValue("amount", mainBal.replaceAll(",", ""));
              }}
            >
              {intl.formatMessage({ id: "all" })}
            </div>
          </div>
          <div className="small d-flex justify-content-end align-items-center">
            <div className="text-muted me-2">
              {intl.formatMessage({ id: "available" })} :
            </div>
            <div className="fw-semibold">
              {auth.currencycode} {mainWallet}
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
